import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectHelpState = (state: AppState) =>
  state.help;


export const selectSectionModify = createSelector(
    selectHelpState,
  (state) => state.sectionModify
);
export const selectSubsectionModify = createSelector(
    selectHelpState,
  (state) => state.subsectionModify
);
export const selectRowModify = createSelector(
    selectHelpState,
  (state) => state.rowModify
);
export const selectHelpList = createSelector(
    selectHelpState,
  (state) => state.helpList
);
export const selectRowCurrent = createSelector(
    selectHelpState,
  (state) => state.rowCurrent
);
export const selectSectionCurrent = createSelector(
    selectHelpState,
  (state) => state.sectionCurrent
);
export const selectSubSectionCurrent = createSelector(
    selectHelpState,
  (state) => state.subsectionCurrent
);
export const selectSections = createSelector(
    selectHelpState,
  (state) => state.sections
);
export const selectSubsections = createSelector(
    selectHelpState,
  (state) => state.subsections
);
export const selectRows = createSelector(
    selectHelpState,
  (state) => state.rows
);
export const selectHelpSearchList = createSelector(
    selectHelpState,
  (state) => state.helpSearchList
);
export const selectViewHelpAllLang = createSelector(
    selectHelpState,
  (state) => state.viewLangHelpAll
);
export const selectHelpGuestLoading = createSelector(
    selectHelpState,
  (state) => state.helpGuestLoading
);
export const selectHelpGuestSearchLoading = createSelector(
    selectHelpState,
  (state) => state.helpGuestSearchLoading
);
export const selectHelpAllLoading = createSelector(
    selectHelpState,
  (state) => state.helpAllLoading
);